import { useEffect, useState } from "react"
import { fetchMyAccessStatus } from "../services/billingService"

const POLL_INTERVAL_MS = 60 * 1000

export function useAccessBlock() {
  const [blocked, setBlocked] = useState(false)
  const [reason, setReason] = useState(null)
  const [supportPhone, setSupportPhone] = useState(null)

  useEffect(() => {
    let cancelled = false

    const check = () => {
      fetchMyAccessStatus()
        .then((res) => {
          if (cancelled) return
          setBlocked(Boolean(res?.data?.blocked))
          setReason(res?.data?.reason ?? null)
          setSupportPhone(res?.data?.supportPhone ?? null)
        })
        .catch(() => {})
    }

    check()
    const interval = setInterval(check, POLL_INTERVAL_MS)
    window.addEventListener("auth-changed", check)

    return () => {
      cancelled = true
      clearInterval(interval)
      window.removeEventListener("auth-changed", check)
    }
  }, [])

  return { blocked, reason, supportPhone }
}
